import { render } from "./Bannner.vue?vue&type=template&id=4235b188&scoped=true"
import script from "./Bannner.vue?vue&type=script&lang=js"
export * from "./Bannner.vue?vue&type=script&lang=js"

import "./Bannner.vue?vue&type=style&index=0&id=4235b188&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4235b188"]])

export default __exports__